import { createContext } from "react";

const locContext = createContext();

export default locContext;